import { Plus } from '@phosphor-icons/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Button } from 'core/components';
import { AddPricingProfile } from 'pricing/components';
import { PricingProfilePricingType } from 'pricing/enums';
import { getPricingProfilePath } from 'pricing/routes';
import { IPricingProfile } from 'pricing/types';
import { Color } from 'theme/enums';

interface IProps {
  type: PricingProfilePricingType;
}

export const AddPricingProfileButton = ({ type }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();
  const navigate = useNavigate();

  const createButtonText =
    type === PricingProfilePricingType.PRICING
      ? t('buttonLabelCreatePricingProfile')
      : t('buttonLabelCreateCostingProfile');

  const onClose = () => {
    setIsOpen(false);
  };

  const onSubmitSuccess = (pricingProfile?: IPricingProfile) => {
    if (pricingProfile) {
      navigate(getPricingProfilePath(type, pricingProfile.id));
    }
  };

  return (
    <>
      <Button
        text={createButtonText}
        color={Color.SUCCESS}
        startDecorator={<Plus />}
        onClick={() => setIsOpen(true)}
      />

      <AddPricingProfile
        type={type}
        isOpen={isOpen}
        onClose={onClose}
        onSubmitSuccess={onSubmitSuccess}
        withValidityDates
      />
    </>
  );
};
